// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2imdv","col":"styles_col__UwuaA"};